import { wireText } from '@/helpers/wireText';

interface IconLayerSpec {
  icon: string;
  variant: string;
  transform?: string;
  /** Optional per-layer color override (defaults to IconConfig.color). */
  color?: string;
}

export interface IconConfig {
  icon: string;
  color: string;
  variant: string;
  /** Når satt, vises stablede ikoner (f.eks. globe + API-badge) i stedet for enkelt-ikon. */
  layerIcons?: IconLayerSpec[];
}

type MenuObjectType =
  | 'folder'
  | 'shortcut'
  | 'system-object'
  | 'database-object'
  | 'report'
  | 'data-view';

const defaultIcon: IconConfig = {
  icon: 'question-circle',
  color: 'rgb(var(--color-accent-default) / 1)',
  variant: 'fal'
};

const objectTypeLabels: Record<MenuObjectType, string> = {
  folder: 'Mappe',
  shortcut: 'Kobling',
  'system-object': 'Datavisning',
  'database-object': 'Databaseobjekt',
  report: 'Rapport',
  'data-view': 'Datavisning'
};

const objectTypeIcons: Record<MenuObjectType, IconConfig> = {
  folder: { icon: 'folder-closed', color: 'rgb(var(--color-accent-default) / 1)', variant: 'fad' },
  shortcut: { icon: 'memo-circle-check', color: 'rgb(var(--color-accent-default) / 1)', variant: 'fal' },
  'system-object': { icon: 'memo-circle-check', color: 'rgb(var(--color-accent-default) / 1)', variant: 'fal' },
  'database-object': { icon: 'memo-circle-info', color: 'rgb(var(--color-accent-default) / 1)', variant: 'fal' },
  report: { icon: 'chart-line-up', color: 'rgb(var(--color-accent-default) / 1)', variant: 'fal' },
  'data-view': { icon: 'hexagon-nodes-bolt', color: 'rgb(var(--color-accent-default) / 1)', variant: 'fad' }
};

function normalizeMenuObjectType (objectType: unknown): MenuObjectType | '' {
  const normalized = wireText(objectType || '').trim().toLowerCase();
  if (
    normalized === 'folder' ||
    normalized === 'shortcut' ||
    normalized === 'system-object' ||
    normalized === 'database-object' ||
    normalized === 'report' ||
    normalized === 'data-view'
  ) {
    return normalized;
  }

  return '';
}

export function getMenuObjectTypeLabel (objectType: unknown): string {
  const normalized = normalizeMenuObjectType(objectType);
  if (!normalized) return '';
  return objectTypeLabels[normalized];
}

export function getMenuObjectTypeIcon (objectType: unknown): IconConfig {
  const normalized = normalizeMenuObjectType(objectType);
  if (!normalized) return defaultIcon;
  return objectTypeIcons[normalized] ?? defaultIcon;
}

export function getDataViewIconByComplexity (isSystemGeneratedDataView: boolean | undefined): IconConfig {
  if (isSystemGeneratedDataView === false) {
    return { icon: 'hexagon-nodes-bolt', color: 'rgb(var(--color-accent-default) / 1)', variant: 'fad' };
  }

  return { icon: 'table-cells-header', color: 'rgb(var(--color-accent-default) / 1)', variant: 'fad' };
}
